// app/javascript/controllers/file_upload_feedback_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'preview'];

  preview() {
    const files = this.inputTarget.files;
    if (files.length === 0) {
      this.previewTarget.style.color = 'gray';
    } else {
      this.previewTarget.classList.remove('tw-hidden');
    }
  }
}
